export default __webpack_public_path__ + "static/media/Hyrkanian Bitter Wind-Biter.16518619.jpg";